/**
 * Renders a granted-scope string as one scope per line instead of a single wrapping run of text.
 *
 * Providers hand these back as an opaque delimited string (`ScopesCsv` on the connection entity, but
 * OAuth itself is space-delimited and that is what Entra and Salesforce actually return), so both
 * delimiters are accepted. Stacking matters most for Dynamics: its scopes are per-org Dataverse URLs
 * that share a long prefix, so on one line the boundary between two of them is invisible.
 *
 * Right-aligned to stay in the summary card's value column, and it renders spans rather than a list
 * so it is valid inside the SummaryRow value span.
 */
export function ScopeList({ scopes }: { scopes: string }) {
    const items = scopes.split(/[\s,]+/).filter(Boolean)
    if (items.length === 0) return null

    return (
        <span className="flex flex-col items-end gap-1">
            {items.map(scope => (
                <span key={scope} className="break-all">{scope}</span>
            ))}
        </span>
    )
}
